import { ActionMetaInfo } from 'mini-app-context/lib/schema/ActionMetaInfo';

/** Returns the data point configuration for appAction */
export function getAppActionMetaData(datapointName: string, customData?: any): ActionMetaInfo {
    return {
        name: datapointName,
        customData,
    };
}
